import React from "react";
import Button from "components/Common/Button";
import PropTypes from "prop-types";
import "./style.scss";

class ModalDelete extends React.Component {
  constructor(props) {
    super(props);

    this.handleDelete = this.handleDelete.bind(this);
  }

  handleDelete() {
    this.props.delete();
    this.props.setState("MODAL", {
      isOpen: false,
      view: ""
    });
  }

  render() {
    return (
      <div className="DeleteModal">
        <h5 className="Modal__title ModalDelete__title">
          {this.props.title}
        </h5>
        <div className="Modal__content ModalDelete__description">
          {this.props.confirmMessage}
        </div>
        <div className="ModalDelete__bottom Modal__bottom">
          <Button
            customClassName="ModalDelete__button__delete ModalDelete__button"
            text="Delete"
            onClick={this.handleDelete}
            light
          />
        </div>
        <div className="ModalDelete__bottom Modal__bottom">
          <Button
            customClassName="ModalDelete__button__cancel ModalDelete__button"
            text="Cancel"
            onClick={() => this.props.setState("MODAL", {
              isOpen: false,
              view: ""
            })}
            light
          />
        </div>
      </div>
    );
  }
}

ModalDelete.isSmall = true;

ModalDelete.propTypes = {
  /** Title */
  title: PropTypes.string.isRequired,
  /** Confirm Message */
  confirmMessage: PropTypes.string.isRequired,
  /** Delete Handler */
  delete: PropTypes.func.isRequired
};

export default ModalDelete;
